export const fadeIn = (
  direction: "up" | "down" | "left" | "right",
  delay: number,
) => {
  return {
    hidden: {
      y: direction === "up" ? 40 : direction === "down" ? -40 : 0,
      x: direction === "left" ? 40 : direction === "right" ? -40 : 0,
      opacity: 0,
    },
    show: {
      y: 0,
      x: 0,
      opacity: 1,
      transition: {
        type: "spring" as const,
        duration: 1.25,
        delay: delay,
      },
    },
  };
};

export const staggerContainer = (
  staggerChildren: number,
  delayChildren: number,
) => {
  return {
    hidden: {},
    show: {
      transition: {
        staggerChildren,
        delayChildren,
      },
    },
  };
};

export const slideIn = (
  direction: "left" | "right" | "up" | "down",
  type: "spring" | "tween" | "inertia",
  delay: number,
  duration: number,
) => {
  return {
    hidden: {
      x: direction === "left" ? "-100%" : direction === "right" ? "100%" : 0,
      y: direction === "up" ? "100%" : direction === "down" ? "100%" : 0,
    },
    show: {
      x: 0,
      y: 0,
      transition: {
        type,
        delay,
        duration,
        ease: "easeOut",
      },
    },
  };
};

export const textVariant = (delay: number) => {
  return {
    hidden: {
      y: 50,
      opacity: 0,
    },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring" as const,
        duration: 1.25,
        delay,
      },
    },
  };
};

export const scale = (delay: number) => {
  return {
    hidden: {
      scale: 0,
      opacity: 0,
    },
    show: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring" as const,
        duration: 1.25,
        delay,
      },
    },
  };
};

export const heightAnimation = {
  initial: {
    height: 0,
  },
  open: {
    height: "85vh",
    transition: { duration: 1, ease: [0.75, 0, 0.23, 1] as const },
  },
  close: {
    height: 0,
    transition: { duration: 1, ease: [0.75, 0, 0.23, 1] as const },
  },
};

export const letterAnim = {
  initial: {
    y: "100%",
    opacity: 0,
  },
  enter: (i: [number, number]) => ({
    y: 0,
    opacity: 1,
    transition: {
      duration: 1,
      ease: [0.6, 0, 0.2, 1] as const,
      delay: i[0],
    },
  }),
  exit: (i: [number, number]) => ({
    y: "100%",
    opacity: 0,
    transition: {
      duration: 0.8,
      ease: [0.6, 0, 0.2, 1] as const,
      delay: i[1],
    },
  }),
};
